/**
 * Labstep
 */

import {
  createSelector,
  createSlice,
  type PayloadAction,
  type SliceCaseReducers,
} from '@reduxjs/toolkit';
import type { Group } from 'labstep-web/models/group.model';
import { selectEntity } from 'labstep-web/state/selectors/entity';
import type { StateActiveGroupId } from './types';

const initialState: StateActiveGroupId = null;

export const activeGroupIdSlice = createSlice<
  StateActiveGroupId,
  SliceCaseReducers<StateActiveGroupId>
>({
  name: 'activeGroupId',
  initialState,
  reducers: {
    setActiveGroupId: (
      state,
      action: PayloadAction<StateActiveGroupId>,
    ) => {
      return action.payload;
    },
  },
});

export const selectActiveGroupId = (state: any) =>
  state.activeGroupId;

export const selectActiveGroup = createSelector(
  (state: any) => state,
  selectActiveGroupId,
  (state: any, id: StateActiveGroupId): Group | null => {
    if (!id) {
      return null;
    }
    return selectEntity(state, 'group', id) as Group | null;
  },
);
export const { setActiveGroupId } = activeGroupIdSlice.actions;

export default activeGroupIdSlice.reducer;
